import React from 'react'
import { AccordionWrapper, useAccordionWrapper } from './accordion-wrapper'
import { AccordionButtonProps } from './types'
import classNames from 'classnames'

export interface AccordionCheckboxProps extends AccordionButtonProps {
  /**
   * Disable the accordion. Effectively disables the checkbox input by adding
   * the utility class `.u-disabled`.
   */
  disabled?: boolean
  /** Id attribute used on the accordion container and checkbox input */
  id?: string
  /** Checked state of the checkbox */
  isChecked: boolean
  /** Callback when the state of the checkbox is changed */
  setChecked: (arg0: boolean) => void

  textCenter?: boolean

  fullWidth?: boolean
}

export const AccordionCheckbox = (props: AccordionCheckboxProps) => {
  const { id, title, disabled, extOpen, children, isChecked, setChecked, textCenter, fullWidth } =
    props

  const accordionWrapperProps = useAccordionWrapper({
    extOpen,
  })

  const { buttonRef, isOpen, setOpen, setButtonClick } = accordionWrapperProps

  const onCheckedClick = (evt: React.MouseEvent<HTMLInputElement>) => {
    evt.stopPropagation()
    setChecked(!isChecked)
  }

  return (
    <>
      <AccordionWrapper
        {...props}
        {...accordionWrapperProps}
        button={
          <button
            className="c-checkbox c-accordion__btn "
            type="button"
            ref={buttonRef}
            onClick={() => {
              setOpen(!isOpen)
              setButtonClick(true)
            }}>
            <div
              className={classNames('d-flex align-items-center', {
                'u-w-100': textCenter || fullWidth,
              })}>
              <input
                type="checkbox"
                id={id}
                name="hardware"
                value={id}
                checked={isChecked}
                onClick={onCheckedClick}
                className={disabled ? 'u-disabled' : ''}
              />
              <div
                className={classNames('u-pl-16', {
                  'u-m-auto u-pl-0': textCenter,
                  'col-12 u-pl-0': fullWidth,
                })}>
                <>{title}</>
              </div>
            </div>
          </button>
        }>
        {children}
      </AccordionWrapper>
    </>
  )
}
